<template>
  <div class="container">
    <!-- {{ myregFormData }} -->
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <Loading v-show="isLoading" />
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">문의하기<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="st_myreg_customize_form">
          <form
            name="myreg_form"
            @submit.prevent="submitInquiry"
            ENCTYPE="multipart/form-data"
            style="margin: 0"
          >
            <input type="hidden" name="tmp_name" value="tmp_val" />
            <input type="hidden" name="this_domain" />
            <input type="hidden" name="post_action" />
            <input type="hidden" name="bu_id" value="" />
            <input type="hidden" name="y" />
            <input type="hidden" name="idx" />
            <input type="hidden" name="me_popup" />
            <input type="hidden" name="mode" />
            <input type="hidden" name="myreg_code" value="reg_01" />
            <input type="hidden" name="user_app_subject" value="" />
            <input type="hidden" name="user_app_goods_name" value="" />
            <input type="hidden" name="user_app_price" value="" />
            <input type="hidden" name="captcha_str_hash" value="" />
            <input type="hidden" name="recaptcha_form_yn" value="0" />
            <input
              type="hidden"
              name="form_sess_id"
              value="716vsn2hkvktapfcokmmb69lg7"
            />
            <input
              type="hidden"
              name="use_emoney_ok"
              id="use_emoney_ok"
              value="0"
            />
            <input type="hidden" name="s_t30" id="nicednb_enc_str" value="" />
            <table class="st_myreg_form">
              <caption>
                기본정보
              </caption>
              <colgroup>
                <col style="width: 250px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>이 름 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.name"
                    />
                  </td>
                </tr>
                <tr>
                  <th>핸드폰 <span class="st_myreg_required">*</span></th>
                  <td>
                    <select
                      name="s_v2_hp1"
                      style="width: 55px"
                      title="휴대전화 첫번째"
                      v-model="myregFormData.phone1"
                    >
                      <option value="">선택</option>
                      <option value="010">010</option>
                      <option value="011">011</option>
                      <option value="016">016</option>
                      <option value="017">017</option>
                      <option value="018">018</option>
                      <option value="019">019</option>
                    </select>
                    -
                    <input
                      type="text"
                      name="s_v2_hp2"
                      size="4"
                      maxlength="4"
                      v-model="myregFormData.phone2"
                      value=""
                      title="휴대전화 두번째"
                    />
                    -
                    <input
                      type="text"
                      name="s_v2_hp3"
                      size="4"
                      maxlength="4"
                      v-model="myregFormData.phone3"
                      value=""
                      title="휴대전화 세번째"
                    />
                  </td>
                </tr>
                <tr>
                  <th>이메일 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v3"
                      id="s_v3"
                      v-model="myregFormData.email"
                      value=""
                    />
                  </td>
                </tr>
                <tr>
                  <th>내 용 <span class="st_myreg_required">*</span></th>
                  <td>
                    <textarea
                      name="s_t1"
                      id="s_t1"
                      v-model="myregFormData.content"
                      style="width: 100%; height: 150px"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <th>파일첨부</th>
                  <td>
                    <NUpload
                      action="#"
                      :default-upload="false"
                      @change="handleUploadChange"
                      :max="1"
                    >
                      <NButton>파일 선택</NButton>
                    </NUpload>
                    <div v-if="uploadedFileName" style="margin-left: 10px">
                      선택된 파일: {{ uploadedFileName }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="st_myreg_agree_wrap st_myreg_mgt">
              <h4 class="st_myreg_title">개인정보 수집·이용 동의</h4>
              <div class="st_myreg_agree">
                <div class="st_myreg_agree_box">
                  <h5>수집하는 개인정보의 항목</h5>
                  <p>
                    회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은
                    개인정보를 수집하고 있습니다.
                  </p>
                  <ul>
                    <li>수집항목 : 이 름, 핸드폰, 이메일, 내 용, 파일첨부</li>
                    <li>개인정보 수집방법 : <span>홈페이지</span></li>
                  </ul>
                  <h5>개인정보의 수집 및 이용목적</h5>
                  <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
                  <ul>
                    <li>연락 및 상담<br /></li>
                  </ul>
                  <h5>개인정보의 보유 및 이용기간</h5>
                  <p>
                    회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이
                    해당 정보를 지체 없이 파기합니다.
                  </p>
                </div>
                <div class="agree_check_box">
                  <input
                    type="checkbox"
                    name="myreg_privacy_chk"
                    id="myreg_privacy_chk"
                    value="1"
                  />
                  <span>
                    <input
                      type="radio"
                      name="myreg_privacy_radio"
                      id="myreg_privacy_radio_agree"
                      value="agree"
                      v-model="myregFormData.privacyAgreement"
                    />
                    <label for="myreg_privacy_radio_agree"
                      >개인정보 수집·이용에 동의합니다.</label
                    >
                  </span>
                  <span>
                    <input
                      type="radio"
                      name="myreg_privacy_radio"
                      id="myreg_privacy_radio_disagree"
                      value="disagree"
                      v-model="myregFormData.privacyAgreement"
                    />
                    <label for="myreg_privacy_radio1"
                      >개인정보 수집·이용에 동의하지 않습니다.</label
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="st_myreg_btn_wrap">
              <button
                type="submit"
                class="st_myreg_btn_type1 st_myreg_highlight"
                :disabled="isLoading"
              >
                {{ isLoading ? "처리 중..." : "확 인" }}
              </button>
            </div>
            <div
              v-if="successMessage"
              class="success-message"
              style="color: blue; margin-top: 10px; text-align: center"
            >
              {{ successMessage }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env"; // Firebase Callable Function
import type { Myreg } from "@/model/myreg"; // Myreg 모델 임포트
import { useAlertDialog } from "@/composables/useAlert";
import * as common from "@/assets/common/common";

const useAlert = useAlertDialog();
import { NButton, NUpload } from "naive-ui";
const router = useRouter();
const uploadAttachmentCallable = getCallable("uploadAttachment");

const initialFormData: Myreg = {
  name: "",
  phone1: "",
  phone2: "",
  phone3: "",
  email: "",
  content: "",
  attached_file_name: "",
  attached_file_drive_id: "",
  privacyAgreement: "", // 'agree' 또는 'disagree'
};

const myregFormData = ref<Myreg>({ ...initialFormData });
const selectedFile = ref<File | null>(null);
const isLoading = ref<boolean>(false);
const successMessage = ref<string | null>(null);
const uploadedFileId = ref<string | null>(null); // 업로드된 파일 ID 저장
const uploadedFileName = ref<string | null>(null); // 업로드된 파일 이름 표시용

async function handleUploadChange(options: {
  file: { file: File | null; status: string };
  fileList: Array<{ file: File | null; status: string }>;
}) {
  const { file } = options;
  if (file.file && file.status !== "removed") {
    uploadedFileName.value = file.file.name; // 파일 이름 표시
    await handleFileUpload(file.file);
  } else if (file.status === "removed") {
    uploadedFileName.value = null;
    uploadedFileId.value = null; // 파일 제거 시 ID도 초기화
  }
}

async function handleFileUpload(file) {
  if (!file) return;
  isLoading.value = true; // 로딩 시작
  const reader = new FileReader();
  reader.readAsDataURL(file); // 파일을 Base64로 읽음
  reader.onload = async () => {
    const base64String = (reader.result as string).split(",")[1]; // 'data:mime/type;base64,' 부분 제거
    try {
      const result = await uploadAttachmentCallable({
        file: {
          base64: base64String,
          name: file.name,
          type: file.type,
        },
      });
      if (common.evalFunctionResult(result)) {
        const fileId = common.getItemFromFunctionResult(result);
        uploadedFileId.value = fileId;
      } else {
        isLoading.value = false; // 로딩 종료
        await useAlert(
          common.getResultError(result) || "파일 업로드 중 오류 발생"
        );
      }
    } catch (error) {
      uploadedFileName.value = null; // 실패 시 파일 이름 표시 제거
      console.error("Error uploading file:", error);
      isLoading.value = false; // 로딩 종료
      await useAlert(error.message || "파일 업로드 중 심각한 오류 발생");
    } finally {
      isLoading.value = false; // 로딩 종료
    }
  };
  reader.onerror = (error) => {
    console.error("Error reading file:", error);
  };
}
const addMyreg = getCallable("addMyreg");

const submitInquiry = async () => {
  successMessage.value = null;

  // 유효성 검사 (간단한 예시)
  if (
    !myregFormData.value.name ||
    !myregFormData.value.phone1 ||
    !myregFormData.value.phone2 ||
    !myregFormData.value.phone3 ||
    !myregFormData.value.email ||
    !myregFormData.value.content
  ) {
    await useAlert("필수 입력 항목을 모두 채워주세요.");
    return;
  }
  if (myregFormData.value.privacyAgreement !== "agree") {
    await useAlert("개인정보 수집·이용에 동의해주세요.");
    return;
  }

  isLoading.value = true;

  try {
    const phoneNumber = `${myregFormData.value.phone1}-${myregFormData.value.phone2}-${myregFormData.value.phone3}`;
    myregFormData.value.phoneNumber = phoneNumber;
    myregFormData.value.attached_file_name = uploadedFileName.value;
    myregFormData.value.attached_file_drive_id = uploadedFileId.value; // 첨부파일 ID 추가

    const result: any = await addMyreg(myregFormData.value);

    if (result.data && result.data.error) {
      throw new Error(result.data.message || "문의 등록에 실패했습니다.");
    }

    myregFormData.value = { ...initialFormData }; // 폼 초기화
    selectedFile.value = null;
    const fileInput = document.getElementById("s_v4") as HTMLInputElement;
    if (fileInput) fileInput.value = ""; // 파일 입력 필드 초기화

    isLoading.value = false;
    await useAlert("문의가 성공적으로 등록되었습니다.");

    // 선택적으로 다른 페이지로 리디렉션
    // router.push(`${USER_ROUTES.Inquiry.Path}`);
  } catch (error: any) {
    console.error("Error submitting inquiry:", error);
    await useAlert(
      error.message ||
        "문의 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
    );
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");

  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub1 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub1 {
  background: #f5f5f5;
  padding: 100px 10px;
  text-align: center;
  line-height: 1.7em;
}

.st_myreg_title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}
.st_myreg_mgt {
  margin-top: 40px;
}
.st_myreg_customize_form > h1 {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
  color: #df0011;
  word-break: keep-all;
}
.st_myreg_form {
  width: 100%;
  border-top: 2px solid #a5a5a5;
  border-bottom: 1px solid #a5a5a5;
  background: #fff;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  margin-bottom: 50px;
}
.st_myreg_form * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_form + .st_myreg_form {
  margin-top: 40px;
}
.st_myreg_form caption {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}
.st_myreg_form tbody tr th {
  position: relative;
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #f5f5f5;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  font-weight: 500;
  border-right: 1px solid #ddd;
}
.st_myreg_form tbody tr td {
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #fff;
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.st_myreg_form tbody tr:first-child th,
.st_myreg_form tbody tr:first-child td {
  border-top-width: 0;
}
.st_myreg_form tbody tr td > input[type="text"],
.st_myreg_form tbody tr td > input[type="number"],
.st_myreg_form tbody tr td > input[type="password"] {
  box-sizing: border-box;
  max-width: 100%;
  height: 30px;
  margin: 2px 0;
  padding: 0 5px;
  border: 1px solid #ddd;
  font-size: 13px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > input[type="radio"],
.st_myreg_form tbody tr td > input[type="checkbox"] {
  margin: 0 5px 0 0;
}
.st_myreg_form tbody tr td > textarea {
  box-sizing: border-box;
  margin: 2px 0;
  padding: 10px;
  border: 1px solid #ddd;
  line-height: 22px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > select {
  height: 30px;
  margin: 2px 0;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > a,
.st_myreg_form tbody tr td > input[type="button"] {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 30px;
  margin: 2px 0 2px 5px;
  padding: 0 15px;
  background: #dfdfdf;
  font-size: 12px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 30px;
  vertical-align: middle;
  cursor: pointer;
}
.st_myreg_form a:hover:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
}
.st_myreg_form label {
  margin-right: 15px;
  cursor: pointer;
}
.st_myreg_form .st_myreg_form_info {
  display: block;
  margin-top: 5px;
  color: #888888;
}
.st_myreg_form .st_myreg_required {
  color: #ef0000;
}
.st_myreg_form #total_price_str {
  vertical-align: top;
}

.st_myreg_payment_type {
  margin: 0 0 20px;
  padding: 15px;
  background: #f4f4f4;
  font-weight: bold;
  color: #777;
  line-height: 22px;
}
.st_myreg_payment_type input {
  margin: 0 5px 0 15px;
}
.st_myreg_payment_type:first-child {
  margin-left: 0;
}
.st_myreg_payment_type label {
  font-size: 13px;
  cursor: pointer;
}
.st_myreg_payment_type font {
  position: relative;
  top: -2px;
  margin-left: 6px;
}
.st_myreg_payment_type * {
  vertical-align: middle;
}
.st_myreg_payment_type br {
  display: none;
}

.st_myreg_btn_wrap {
  margin: 30px 0 0;
  padding: 0;
  text-align: center;
}
.st_myreg_btn_wrap a,
.st_myreg_btn_wrap button {
  margin: 2px 0;
}
.st_myreg_btn_wrap * {
  vertical-align: top;
}

.st_myreg_agree_wrap .st_myreg_title {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  font-size: 15px;
}
.st_myreg_agree_wrap .st_myreg_agree {
  padding: 10px;
  background: #f6f6f6;
}
.st_myreg_agree_wrap .st_myreg_agree_box {
  display: block;
  overflow: auto;
  height: 150px;
  padding: 30px;
  border: 1px solid #ddd;
  background: #fff;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5 {
  margin-bottom: 10px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5:first-child {
  margin-top: 0;
}
.st_myreg_agree_wrap .st_myreg_agree_box p,
.st_myreg_agree_wrap .st_myreg_agree_box ul,
.st_myreg_agree_wrap .st_myreg_agree_box ol {
  margin: 0;
  padding: 0;
  font-size: 13px;
  list-style-type: none;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box li {
  margin-bottom: 10px;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box p {
  margin-bottom: 10px;
}

.st_myreg_agree_wrap .agree_check_box {
  margin: 10px 0 0;
}
.st_myreg_agree_wrap .agree_check_box:after {
  content: "";
  display: block;
  clear: both;
}
.st_myreg_agree_wrap .agree_check_box span {
  display: inline-block;
}
.st_myreg_agree_wrap .agree_check_box input {
  float: left;
}
.st_myreg_agree_wrap .agree_check_box label {
  float: left;
  margin-left: 5px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .agree_check_box input[type="checkbox"] {
  display: none;
}

.st_myreg_btn_type1 {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 45px;
  margin: 0;
  padding: 12px 30px;
  background: #dfdfdf;
  background: #dfdfdf;
  font-family: "Malgun Gothic", sans-serif;
  font-size: 13px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 21px;
  cursor: pointer;
}
.st_myreg_btn_type1:hover:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
}
.st_myreg_btn_type1.st_myreg_highlight {
  background: #4e4e4e;
  color: #ffffff;
}
.st_myreg_btn_type1.st_myreg_highlight:hover:before {
  background: rgba(255, 255, 255, 0.15);
}

@media all and (max-width: 767px) {
  .st_myreg_form:after {
    content: "";
    display: block;
    clear: both;
  }
  .st_myreg_form colgroup {
    display: none;
  }
  .st_myreg_form tbody tr th {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: left;
    border-right: none;
  }
  .st_myreg_form tbody tr th:after {
    display: none;
  }
  .st_myreg_form tbody tr td {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 0 10px 10px;
    border-top-width: 0;
  }

  .st_myreg_payment_type br {
    display: block;
  }
  .st_myreg_payment_type input {
    margin-left: 0;
  }
  .st_myreg_agree_wrap .st_myreg_agree_box {
    height: 100px;
  }
}
</style>
